import { ReconciliationCommentary, RevisionType } from '@aloft/toolkit-shared';

export type PreviousComparableCommentary = {
  revisionType: RevisionType;
  commentary: string;
};

type PreviousHistory = NonNullable<
  ReconciliationCommentary['previousAlternativeComparablesCommentaries']
>;

const getOrderedHistories = (histories: PreviousHistory | undefined) =>
  [...(histories ?? [])]
    .map((history) => ({
      revisionType: (history.revisionType ?? 'revision') as RevisionType,
      comparables: history.comparables.filter(({ commentary }) => commentary.trim().length > 0),
    }))
    .filter(({ comparables }) => comparables.length > 0)
    .reverse();

export const getPreviousCommentariesForAddress = (
  histories: PreviousHistory | undefined,
  address: string,
): PreviousComparableCommentary[] =>
  getOrderedHistories(histories).flatMap(({ revisionType, comparables }) =>
    comparables
      .filter((comparable) => comparable.address === address)
      .map(({ commentary }) => ({ revisionType, commentary })),
  );

export const getUnmatchedPreviousAlternativeComparables = (
  histories: PreviousHistory | undefined,
  currentAddresses: string[],
) => {
  const currentAddressSet = new Set(currentAddresses);
  return getOrderedHistories(histories).flatMap(({ revisionType, comparables }) =>
    comparables
      .filter((comparable) => !currentAddressSet.has(comparable.address))
      .map(({ address, commentary }) => ({ revisionType, address, commentary })),
  );
};
